import { render, staticRenderFns } from "./fapiaoarr.vue?vue&type=template&id=d66def04&scoped=true"
import script from "./fapiaoarr.vue?vue&type=script&lang=js"
export * from "./fapiaoarr.vue?vue&type=script&lang=js"
import style0 from "./fapiaoarr.vue?vue&type=style&index=0&id=d66def04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66def04",
  null
  
)

export default component.exports